import { render, staticRenderFns } from "./GoldSilverStock.vue?vue&type=template&id=487d35c8&scoped=true&"
import script from "./GoldSilverStock.vue?vue&type=script&lang=js&"
export * from "./GoldSilverStock.vue?vue&type=script&lang=js&"
import style0 from "./GoldSilverStock.vue?vue&type=style&index=0&id=487d35c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487d35c8",
  null
  
)

export default component.exports